module.exports = __webpack_public_path__ + "1c7b41c180cb3365ccfa78b4702e64d8.MP3";